import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { PortfolioItem } from "@/hooks/profile";
export function usePortfolioItemsQuery(profileId?: string) {
  return useQuery({
    queryKey: ["portfolioItems", profileId],
    queryFn: async (): Promise<PortfolioItem[]> => {
      const { data, error } = await supabase.from("profiles").select("portfolio_items").eq("id", profileId!).maybeSingle();
      if (error) throw error;
      return Array.isArray(data?.portfolio_items) ? (data.portfolio_items as unknown as PortfolioItem[]).filter(item => item && item.status !== "draft") : [];
    }, enabled: !!profileId, staleTime: 5 * 60 * 1000,
  });
}
